/**
 * @file 检查是否有某个class
 * @author Wanzhongyun
 */

const hasClass = (element: Element, className: string) => {
    return ` ${element.className} `.indexOf(` ${className} `) > -1;
};

export default hasClass;
